import { httpClient } from "@/app/client/httpClient";
import { LeaveBody } from "@/types/user/LeaveBody";

/* eslint-disable @typescript-eslint/no-namespace */
export namespace V2 {
  export class AccountService {
    canLeave() {
      return httpClient.accounts.v2.leave.can_leave.$get();
    }
    leave(body: LeaveBody) {
      return httpClient.accounts.v2.leave.$post({ body });
    }
  }
}

export const AccountService = new V2.AccountService();
